import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Register our semantic z-index tokens (z-dialog, z-sheet, z-device-picker, …,
// defined in packages/shared/tailwindcss/base.css) as z-index utilities so
// tailwind-merge dedupes them against each other and against numeric/arbitrary
// z classes when a component's built-in overlay/content z is overridden by a
// caller. Every `z-<word>` class in Tailwind is a z-index utility, so a
// kebab-word matcher covers current and future tokens without upkeep.
const twMerge = extendTailwindMerge({
   extend: {
      classGroups: {
         z: [{ z: [(value: string) => /^[a-z][a-z-]*$/.test(value)] }],
      },
   },
});

export function cn(...inputs: ClassValue[]) {
   return twMerge(clsx(inputs));
}
